export default __webpack_public_path__ + "static/media/x.e9ec1ae9.svg";